import React, { FunctionComponent, useState, useEffect } from 'react';
import withStyles from 'react-jss';
import { Modal, Header } from 'semantic-ui-react';
import { Storage } from 'aws-amplify';
import { useForm } from 'react-hook-form';
import { ClassProp } from 'helpers/types';
import { toastMapping } from 'components/ErrorBoundary/ErrorBoundary';

import styles from './FillMUGModal.styles';
import classnames from 'classnames';

type Styles = ClassProp<ReturnType<typeof styles>>;

type FormData = {
  nameOfMug: string;
  files: File[];
};

type Props = {
  trigger: any;
  classes: Styles;
};

const FillMUGModal: FunctionComponent<Props> = ({ trigger, classes }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fileUploaded, setFileUploaded] = useState<boolean>(false);

  const { register, handleSubmit } = useForm<FormData>();

  const onSubmit = async (data: FormData) => {
    setLoading(true);

    const {
      nameOfMug: nameOfMug,
      files: [file],
    } = data;

    const fileName = `upsert_mug_membership.name.${nameOfMug}.status.ACTIVE.additions.${Date.now()}.csv`;

    try {
      await Storage.put(
        `marketplace-user-groups/upsert_mug_membership/input/${fileName}`,
        file,
        {
          contentType: 'text/csv',
          bucket: process.env.MARKETPLACE_BUCKET,
          region: process.env.AWS_REGION,
        },
      );

      setFileUploaded(true);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (fileUploaded) {
      toastMapping(
        {},
        'success',
      )([
        {
          message: 'File has been successfully uploaded',
          displayMessage: 'Success',
        },
      ]);
    }
  }, [fileUploaded]);
  return (
    <Modal trigger={trigger} closeIcon size="mini">
      <Header
        className={classes.header}
        icon="upload"
        content="Upload MUG CSV"
      />

      <Modal.Content>
        <form onSubmit={handleSubmit(onSubmit)}>
          <label className={classes.label}>MUG Name</label>
          <input
            name="nameOfMug"
            type="text"
            ref={register({ required: true })}
            className={classes.file}
          />
          <label className={classes.label}>Upload MUG csv</label>
          <input
            name="files"
            type="file"
            accept="text/csv"
            ref={register({ required: true })}
            className={classes.file}
          />
          <input
            disabled={loading}
            type="submit"
            value={loading ? 'Loading...' : 'Upload'}
            className={classnames(classes.submit, {
              [classes.disabled]: loading,
            })}
          />
        </form>
      </Modal.Content>
    </Modal>
  );
};

export default withStyles(styles)(FillMUGModal);
